import { useState } from "react";
import Table from "../../../components/ui/table";
import { TPatientDetails, TTableUser } from "../../../types";
import { patientTableColumns } from "../../appointments/utils/data";
import { Button, Flex } from "@chakra-ui/react";
import colors from "../../../utils/colors";
import { actions } from "../../../assets";
import { ClipLoader } from "react-spinners";
import PatientsActionsList from "./PatientsActionList";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getAge } from "../utils";

interface IProps {
  setIsDetailsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsUpdatePatientModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  // setUser: React.Dispatch<React.SetStateAction<TTableUser>>;
  patients: any;
  loadingPatients?: boolean;
  //totalPatients: number;
  setSelectedPatient: React.Dispatch<React.SetStateAction<TPatientDetails>>;
}

export const renderAppointmentTypeCell = (type: string) => {
  if (type === "High Risk") {
    return (
      <Button
        bgColor={"#FCCFCF"}
        color={colors.red}
        fontFamily={"lato"}
        fontSize={"12px"}
        padding={"0px 15px"}
        height={"29px"}
        width={"84px"}
        borderRadius={"20px"}
      >
        High Risk
      </Button>
    );
  } else if (type === "Medium Risk") {
    return (
      <Button
        bgColor={"#FBFCCF"}
        color={"#695F04"}
        fontFamily={"lato"}
        fontSize={"12px"}
        padding={"0px 15px"}
        height={"29px"}
        width={"84px"}
        borderRadius={"20px"}
      >
        Medium Risk
      </Button>
    );
  } else if (type === "Low Risk") {
    return (
      <Button
        bgColor={"#DDFFF5"}
        color={colors.primary}
        fontFamily={"lato"}
        fontSize={"12px"}
        padding={"0px 15px"}
        height={"29px"}
        width={"84px"}
        borderRadius={"20px"}
      >
        Low Risk
      </Button>
    );
  } else {
    return (
      <Button
        bgColor={colors.grey}
        color={colors.dark}
        fontFamily={"lato"}
        fontSize={"12px"}
        padding={"0px 15px"}
        height={"29px"}
        width={"84px"}
        borderRadius={"20px"}
      >
        Inactive
      </Button>
    );
  }
};

const PatientsTable = ({
  setIsDetailsModalOpen,
  //setUser,
  setIsUpdatePatientModalOpen,
  loadingPatients = false,
  patients,
  setSelectedPatient,
}: IProps) => {
  const [openAction, setOpenAction] = useState(false);
  const [clickedUserId, setClickedUserId] = useState("");
  const navigate = useNavigate();
  const rows = patients?.map((patient) => ({
    "Patient Name": patient?.name,
    "Patient ID": patient?.patientId,
    "Patient DOB": moment(patient?.dateOfBirth).format("MMM DD, YYYY"),
    "Patient Age": getAge(moment(patient?.dateOfBirth).format("MMM DD, YYYY")),
    "Phone Number": patient?.phoneNumber.toString(),
    "Patient Height": patient?.height?.toString(),
    "Patient Weight": patient?.weight?.toString(),
    "Patient Gender": patient?.gender,
    "Patient Blood Genotype": patient?.bloodGenotype,
    "Patient Blood Group": patient?.bloodGroup,
    "Patient email": patient?.email,
    "Patient Address": patient?.address,
    "Date Registered": moment(patient?.dateRegistered)?.format("DD MMM YYYY"),
    "Patient Notes": patient?.patientNotes,
    Category: patient?.riskCategory,

    Actions: actions,
  }));

  const onClickDots = (column: string, id: string) => {
    if (column === "Actions") {
      setOpenAction(true);
      setClickedUserId(id);
    }
  };
  const displayActions = (column: string, id: string) => {
    if (column === "Actions" && openAction && id === clickedUserId) {
      return (
        <PatientsActionsList
          onClose={setOpenAction}
          openDetailsModal={setIsDetailsModalOpen}
          openUpdatePatientModal={setIsUpdatePatientModalOpen}
        />
      );
    }
  };
  const renderActionsCell = (icon: string, column: string, row: any) => {
    return (
      <img
        src={icon}
        alt=""
        onClick={() => {
          onClickDots(column, row["Patient ID"]);
          setSelectedPatient(row);
        }}
        className="cursor-pointer"
      />
    );
  };

  return (
    <>
      {loadingPatients ? (
        <Flex justifyContent={"center"} alignItems={"center"} py={"100px"}>
          <ClipLoader color={colors.primary} size={"40px"} />
        </Flex>
      ) : (
        <Table
          displayActions={displayActions}
          columns={patientTableColumns}
          data={rows}
          renderCell={(cellData, row, column) => {
            if (column === "Actions") {
              return renderActionsCell(cellData, column, row);
            } else if (column === "Category") {
              return renderAppointmentTypeCell(cellData);
            }
            return cellData;
          }}
          isClickable={true}
          handleClick={(id) => navigate(`/patients/${id}`)}
        />
      )}
    </>
  );
};

export default PatientsTable;
